const useNavigateItems = ({ items, selectedItemId }) => {
  const currentIndex = items?.findIndex(item => item.id === selectedItemId) ?? -1

  const isSelected = currentIndex >= 0
  const hasPrev = currentIndex > 0
  const hasNext = isSelected && currentIndex < items?.length - 1

  const onPrevItem = () => {
    if (!hasPrev) return null

    return items[currentIndex - 1]
  }

  const onNextItem = () => {
    if (!hasNext) return null

    return items[currentIndex + 1]
  }

  return {
    onPrevItem,
    onNextItem,
    hasPrev,
    hasNext,
  }
}

export default useNavigateItems
